var _circle, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlageMacDestination(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 55,
    fill: "#F1F1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.9999 101.168C80.4977 101.168 101.168 80.4977 101.168 54.9999C101.168 29.5021 80.4977 8.83203 54.9999 8.83203C29.5021 8.83203 8.83203 29.5021 8.83203 54.9999C8.83203 80.4977 29.5021 101.168 54.9999 101.168Z",
    fill: "url(#paint0_linear_7644_78224)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5274 73.569L46.6757 57.7272L33.2031 47.943H49.8645L55.0128 32.0884L60.1611 47.943H76.8097L63.3371 57.7272L68.4854 73.569L55.0128 63.772L41.5274 73.569ZM57.6382 61.8638L62.5687 65.4496L60.6861 59.6482L57.6382 61.8638ZM49.3139 59.6482L47.4313 65.4496L52.3618 61.8638L49.3139 59.6482ZM50.3256 56.549L55.0128 59.9556L59.7 56.549L57.9199 51.055H52.1313L50.3256 56.549ZM42.7569 51.0422L47.6874 54.6152L48.8528 51.0422H42.7569ZM62.3254 54.628L67.2559 51.055H61.1728L62.3254 54.628ZM53.1174 47.943H56.8954L55.0128 42.1416L53.1174 47.943Z",
    fill: "#00833E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7644_78224",
    x1: 8.83203,
    y1: 55.0004,
    x2: 101.169,
    y2: 55.0004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE1A17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE1A17"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlageMacDestination);
export default __webpack_public_path__ + "static/media/flageMACDestination.ae7cde228090453b569ffaf446ddf59f.svg";
export { ForwardRef as ReactComponent };